import type { Api, Stat } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function snapShot(pageNumber?: number | string): Promise<Api.Result<Stat.Snapshot>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/stat/snapshot?page_number=${pageNumber || 1}`, {
      method: 'GET',
      headers,
      next: { revalidate: 5 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
